import PropTypes from "prop-types"
import React from "react"
import PersonIcon from "@material-ui/icons/Person"
import { Typography, Box, Avatar, useTheme } from "@material-ui/core"

import useStyles from "./styles"
import useIsGTT from "../../../../hooks/useIsGTT"

const RoleIdentityComponent = ({
  role = {},
  showAvatar = false,
  crewFacing = false,
}) => {
  const classes = useStyles()
  const theme = useTheme()

  // const location = window.location.pathname

  // const matchesDealMemo = matchPath(location, {
  //   path: "/deal-memo/:short_code",
  // })

  // const matchesCrewBill = matchPath(location, {
  //   path: "/crew-bill/:short_code",
  // })

  let profileImage =
    (role && role.profile_image && JSON.parse(role.profile_image).url) || ""

  let isGttMember = useIsGTT(role)
  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      {showAvatar && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          marginRight="10px"
        >
          <Avatar
            alt="User avatar"
            src={profileImage}
            className={classes.avatar}
          >
            <PersonIcon className={classes.userIcon} />
          </Avatar>
          {isGttMember &&
            !crewFacing && (
              <Typography
                style={{
                  color: theme.palette.secondary.main,
                  fontWeight: 700,
                  textShadow: "1px 1px silver",
                }}
              >
                GTT
              </Typography>
            )}
        </Box>
      )}
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <Typography className={classes.userName}>
          {role.first_name
            ? `${role.first_name} ${role.last_name}`
            : "Unassigned"}
        </Typography>
        <Typography className={classes.roleName}>{role.name}</Typography>
      </Box>
    </Box>
  )
}

RoleIdentityComponent.propTypes = {
  role: PropTypes.object,
  showAvatar: PropTypes.bool,
  crewFacing: PropTypes.bool,
}

export default RoleIdentityComponent
